import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import Particle from "../Particle";
import Projects1 from "./Projects1";

function useScrollAnimation() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = React.useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 }
    );

    const currentRef = ref.current;
    if (currentRef) observer.observe(currentRef);
    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, []);

  return [ref, isVisible];
}

function AnimatedSection({ children, className = "", delay = 0 }) {
  const [ref, isVisible] = useScrollAnimation();
  
  return (
    <div
      ref={ref}
      className={`scroll-animate ${isVisible ? "animate-in" : ""} ${className}`}
      style={{ animationDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}

function Projects() {
  return (
    <Container fluid className="projects-section">
      <Particle />
      <Container className="projects-container">
        <AnimatedSection className="projects-header">
          <span className="projects-badge">
            <span className="badge-dot"></span>
            Trusted Infrastructure
          </span>
          <h1 className="projects-title">
            Our Supported <span className="gradient-text">Projects</span>
          </h1>
          <p className="projects-subtitle">
            Building the future of blockchain infrastructure together
          </p>
        </AnimatedSection>

        <AnimatedSection delay={200}>
          <div className="stats-banner">
            <div className="stat-item">
              <span className="stat-value">50+</span>
              <span className="stat-label">Projects</span>
            </div>
            <div className="stat-divider-v"></div>
            <div className="stat-item">
              <span className="stat-value">99.9%</span>
              <span className="stat-label">Uptime</span>
            </div>
            <div className="stat-divider-v"></div>
            <div className="stat-item">
              <span className="stat-value">200+</span>
              <span className="stat-label">Nodes</span>
            </div>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={300} className="projects-list-section">
          <Projects1 />
        </AnimatedSection>

        <AnimatedSection delay={400} className="cta-section">
          <div className="projects-cta">
            <h2>Ready to Join Our Network?</h2>
            <p>Experience enterprise-grade validator infrastructure</p>
            <div className="cta-stats">
              <div className="cta-stat">
                <span className="status-indicator"></span>
                <span className="cta-stat-value">150+</span>
                <span className="cta-stat-label">Active Nodes</span>
              </div>
              <div className="cta-stat">
                <span className="cta-stat-value">$2B+</span>
                <span className="cta-stat-label">Total Staked</span>
              </div>
              <div className="cta-stat">
                <span className="cta-stat-value">99.9%</span>
                <span className="cta-stat-label">Uptime</span>
              </div>
            </div>
          </div>
        </AnimatedSection>
      </Container>
    </Container>
  );
}

export default Projects;
